import React from 'react';

// Simple hash function (FNV-1a)
function hashString(str) {
  let hash = 2166136261;
  for (let i = 0; i < str.length; i++) {
    hash ^= str.charCodeAt(i);
    hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
  }
  return hash >>> 0;
}

// Generate 8x8 pixel data from wallet address
function generatePixelData(address) {
  const hash = hashString(address);
  const pixels = [];
  for (let y = 0; y < 8; y++) {
    for (let x = 0; x < 8; x++) {
      // Use bits from the hash to determine pixel on/off
      const bit = (hash >> ((x + y * 8) % 32)) & 1;
      pixels.push(bit);
    }
  }
  return pixels;
}

// Generate a color from the address
function generateColor(address) {
  const hash = hashString(address);
  // Use parts of the hash for RGB
  const r = (hash & 0xFF0000) >> 16;
  const g = (hash & 0x00FF00) >> 8;
  const b = hash & 0x0000FF;
  return `rgb(${r},${g},${b})`;
}

// Avatar component
export function PixelAvatar({ address, size = 32 }) {
  const pixels = generatePixelData(address);
  const color = generateColor(address);
  const pixelSize = size / 8;

  return (
    <svg width={size} height={size} style={{ background: '#111', borderRadius: 4 }}>
      {pixels.map((on, i) => {
        const x = i % 8;
        const y = Math.floor(i / 8);
        return on ? (
          <rect
            key={i}
            x={x * pixelSize}
            y={y * pixelSize}
            width={pixelSize}
            height={pixelSize}
            fill={color}
          />
        ) : null;
      })}
    </svg>
  );
} 